import { IconPlus } from '@tabler/icons-react'

import { AstraCallout, AstraIcon } from '~/astra'

import { DatePickerField } from '../../Form/DatePickerField'
import { withFieldGroup } from '../../Form/formHooks'
import { FieldGroupWrapper } from '../../Form/FormWrapper'
import { createFormFieldProps } from '../../Form/utils'
import { FormServicePeriod } from './formState'

const defaultValues: FormServicePeriod = {
    startDate: undefined,
    endDate: undefined,
}

export const ServicePeriodGroupField = withFieldGroup({
    defaultValues,
    render: function Render({ group }) {
        return (
            <FieldGroupWrapper className="flex-1">
                <group.AppField name="startDate">
                    {field => (
                        <DatePickerField
                            label="Aktiv fra"
                            value={field.state.value}
                            buttonFullWidth={true}
                            {...createFormFieldProps(field, { blurOnChange: true })}
                        />
                    )}
                </group.AppField>
                <group.AppField name="endDate">
                    {field => (
                        <DatePickerField
                            label="Aktiv til"
                            value={field.state.value}
                            buttonFullWidth={true}
                            startMonth={group.state.values.startDate}
                            {...createFormFieldProps(field, { blurOnChange: true })}
                        />
                    )}
                </group.AppField>
            </FieldGroupWrapper>
        )
    },
})

type EmptyServicePeriodsProps = {
    onAddClick?: () => void
}
export const EmptyServicePeriods = ({ onAddClick }: EmptyServicePeriodsProps) => (
    <AstraCallout
        color="info"
        text="Ingen tjenesteperiode spesifisert. Kirurgen vil alltid være aktiv."
        action={onAddClick ? { label: 'Legg til tjenesteperiode', onClick: onAddClick, icon: <AstraIcon icon={IconPlus} /> } : undefined}
    />
)
